import { Routes } from '@angular/router';
import { FaqRoute } from './faq.route';
import { MainPageLayoutComponent } from 'app/component/main-page-layout/main-page-layout.component';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';
import { RouteSubComponent } from 'authorization';

export const faqRouting: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    children: [
      {
        path: '',
        redirectTo: 'status_summary',
        pathMatch: 'full',
      },
      {
        path: 'create_faqs',
        loadComponent: () =>
          import('./app/component/create-faqs/create-faqs.component').then(
            (c) => c.CreateFAQsComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ایجاد سوالات متداول',
            parent: ['سوالات متداول'],
            parentUrl: [SiteManagmentRoute.map.faq.dashboard.faqs_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof FaqRoute.map.dashboard, 'create_faqs'>,
      {
        path: 'faqs_list',
        loadComponent: () =>
          import('./app/component/list-faqs/list-faqs.component').then(
            (c) => c.ListFaqsComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
          title: '',
        },
      } as RouteSubComponent<typeof FaqRoute.map.dashboard, 'faqs_list'>,

      {
        path: 'edit_faqs',
        loadComponent: () =>
          import('./app/component/edit-faqs/edit-faqs.component').then(
            (c) => c.EditFaqsComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ویرایش سوالات متداول',
            parent: ['سوالات متداول'],
            parentUrl: [SiteManagmentRoute.map.faq.dashboard.faqs_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof FaqRoute.map.dashboard, 'edit_faqs'>,
    ],
  },

  {
    path: 'mainpage',
    component: MainPageLayoutComponent,
    children: [
      {
        path: 'view_faqs',
        loadComponent: () =>
          import('./app/component/app-view-faqs/app-view-faqs.component').then(
            (c) => c.AppViewFaqsComponent,
          ),
      } as RouteSubComponent<typeof FaqRoute.map.mainpage, 'view_faqs'>,
    ],
  },
];
